import Vue from 'vue';
import store from './../../store';
import clientTypeTransformer from './../../transformers/clientType';

const success = ({ data }, resolve) => {
  const clientTypes = clientTypeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllClientTypes', clientTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display order types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('client_types')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/clientType/all.js